import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'matricula-home-barra',
  standalone: false,
  template: `
  <div class="header-mainInfo">
      <h1 class="">MiGLM/Matrículas</h1>
  </div>`,
})
export class MatriculaHomeBarraComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
